import React, { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Alert, CircularProgress, Container, Stack } from '@mui/material';
import { useAdminAuth } from '../context/AdminAuthContext';

function buildDnnLoginUrl() {
  const returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return `/Login?returnurl=${encodeURIComponent(returnUrl)}`;
}

export function AdminRoute() {
  const { loading, hasAdminAccess } = useAdminAuth();
  const loginUrl = useMemo(() => buildDnnLoginUrl(), []);
  const [redirectStarted, setRedirectStarted] = useState(false);

  useEffect(() => {
    if (loading || hasAdminAccess) {
      sessionStorage.removeItem('escape_room_admin_redirect');
      return;
    }

    const lastRedirect = sessionStorage.getItem('escape_room_admin_redirect');
    if (lastRedirect === loginUrl) {
      return;
    }

    sessionStorage.setItem('escape_room_admin_redirect', loginUrl);
    setRedirectStarted(true);
    window.location.assign(loginUrl);
  }, [loading, hasAdminAccess, loginUrl]);

  if (loading) {
    return (
      <Container>
        <Stack alignItems="center" sx={{ py: 8 }}>
          <CircularProgress />
        </Stack>
      </Container>
    );
  }

  if (!hasAdminAccess) {
    if (redirectStarted) return null;
    return (
      <Container>
        <Stack sx={{ py: 4 }}>
          <Alert severity="warning">Nemate prava pristupa admin sucelju.</Alert>
        </Stack>
      </Container>
    );
  }

  return <Outlet />;
}
